import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getFranklyNetArticle, getFranklyNetEntity } from '../../services/api';
import DocArticle from '../../components/franklynet/DocArticle';
import DocEntity from '../../components/franklynet/DocEntity';

function DocFrame({ children }) {
    return (
        <div className="min-h-screen w-full bg-white">
            <div className="mx-auto w-full max-w-[860px] px-4 py-5 sm:px-6">
                {children}
            </div>
        </div>
    );
}

function DocMessage({ heading, detail }) {
    return (
        <DocFrame>
            <div className="border border-gray-300 bg-offwhite p-8 text-center">
                <p className="font-['Jersey_10'] text-[22px] uppercase text-maroon">{heading}</p>
                {detail && <p className="mt-2 text-[14px] text-gray-600">{detail}</p>}
            </div>
        </DocFrame>
    );
}

function FranklyNetDoc() {
    const { kind, slug } = useParams();
    const [payload, setPayload] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError(null);
        setPayload(null);

        const request = kind === 'entity'
            ? getFranklyNetEntity(slug)
            : getFranklyNetArticle(slug);

        request
            .then(res => {
                if (!active) return;
                if (res.success) setPayload(res);
                else setError(res.message || 'Frank does not have that on file.');
            })
            .catch(() => { if (active) setError('Frank could not open that one.'); })
            .finally(() => { if (active) setLoading(false); });

        return () => { active = false; };
    }, [kind, slug]);

    useEffect(() => {
        const title = payload?.article?.title || payload?.entity?.name;
        document.title = title ? `${title} - AskFrank` : 'AskFrank';
    }, [payload]);

    if (loading) return <DocMessage heading="Opening..." />;
    if (error) return <DocMessage heading="Not on file" detail={error} />;

    if (kind === 'entity' && payload?.entity) {
        return (
            <DocFrame>
                <DocEntity entity={payload.entity} />
            </DocFrame>
        );
    }

    if (payload?.article) {
        return (
            <DocFrame>
                <DocArticle article={payload.article} related={payload.related || []} />
            </DocFrame>
        );
    }

    return <DocMessage heading="Nothing here" detail="Frank has no page under that address." />;
}

export default FranklyNetDoc;
